var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "110px",
    height: "100px",
    viewBox: "0 0 110 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_success") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI-Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2_Landing-page---sent-message",
    transform: "translate(-664, -366)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(394, 306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_success",
    transform: "translate(270, 60)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#2C3808",
    cx: 62.1592272,
    cy: 50,
    rx: 47.8407728,
    ry: 47.5812847
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.2812483,0 C78.0060705,0 100.562497,22.4340803 100.562497,50 C100.562497,77.5659197 78.0060705,100 50.2812483,100 C22.5564262,100 0,77.5659197 0,50 C0,22.4340803 22.5564262,0 50.2812483,0 Z M50.2812483,4.83743061 C25.2483294,4.83743061 4.88095112,25.0943363 4.88095112,50 C4.88095112,74.9056637 25.2483294,95.1625694 50.2812483,95.1625694 C75.3141673,95.1625694 95.6815456,74.9056637 95.6815456,50 C95.6815456,25.0943363 75.3141673,4.83743061 50.2812483,4.83743061 Z M69.7729028,32.4711308 C70.6550654,31.5578572 72.1071671,31.4672548 73.1051855,32.2918328 C74.1387481,33.1457779 74.2775163,34.6639483 73.4169819,35.6871275 L48.7026157,65.1898462 C47.7869341,66.2827042 46.438476,66.9467658 45.0018956,67.0118958 L44.7848751,67.0103093 C43.4293378,67.0103093 42.1191037,66.4711214 41.1755501,65.5246304 L27.2864192,51.7108142 C26.3368208,50.7663663 26.3368208,49.2389205 27.2864192,48.2944726 C28.2407505,47.3453177 29.7912992,47.3453177 30.7456305,48.2944726 L43.6097093,61.0834899 L44.8037165,62.2705301 L45.8850131,60.9799641 L69.6671928,32.5950844 L69.732,32.516 Z",
    id: "Combined-Shape",
    fill: "#BFE82D"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccess);
export default __webpack_public_path__ + "static/media/ic_success.4f0d3cb4252d6ff2bac2676a17fe833c.svg";
export { ForwardRef as ReactComponent };